// extracted by mini-css-extract-plugin
export default {"wrapper":"PhotoModal_wrapper__Jt68t","visible":"PhotoModal_visible__xijua","content":"PhotoModal_content__pWO7N","closeIcon":"PhotoModal_closeIcon__VgSY7"};